module.exports = __webpack_public_path__ + "img/img5.9d44bfcf.svg";